export const fnFormatoNumMiles = (value: number, decimales: number): string => {
  return new Intl.NumberFormat('es-PE', {maximumFractionDigits: decimales, minimumFractionDigits: decimales}).format(value);
}

export const fnFormatoNumAbrev = (value: number): string => {
  let aux = "";
  if (value < 1000) aux = value.toString();
  else if (value >= 1000 && value < 1000000) aux = value / 1000 + " K";
  else if (value >= 1000000) aux = value / 1000000 + " MM";
  return aux;
}

export const generarColorMarron = (isSoles: boolean) => {

  /*var rojo = Math.floor(Math.random()*5);
  var verde = Math.floor(Math.random()*8);
  var azul = Math.floor(Math.random()*3) ;

  var color = 'rgba(' + rojo + ', ' + verde + ', ' + azul + ', ' + (isSoles ? 0.6 : 0.85) + ')';
*/

  let result = '';
  for (let i = 0; i < 6; ++i) {
    const value = Math.floor(16 * Math.random());
    result += value.toString(16);
  }
  return '#' + result;

  //return color;

}

const randomColor = (): string => {
  let result = '';
  for (let i = 0; i < 6; ++i) {
    const value = Math.floor(16 * Math.random());
    result += value.toString(16);
  }
  return '#' + result;
};

